export enum EditStatus {
    SUCCESS = 'SUCCESS',
    NOT_PERFORMED = 'NOT_PERFORMED',
    ERROR = 'ERROR_SYSTEM',
    USER_WITH_NO_EMAIL_CODE = 'EMAIL_NOT_FOUND_OR_PROVIDED',
    ALREADY_IN_PROGRESS = 'ALREADY_IN_PROGRESS',
}
